// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__bzXtJ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3jBiV"};